import {
  fetchCountriesFailed,
  fetchCountriesSuccess,
  fetchCountriesInvoked,
  COUNTRIES_FETCH_DATA,
} from "src/redux/actions/countries";

import { put, call, takeLatest, select } from "redux-saga/effects";
import { fetchData } from "src/services/countries";
import { CountriesI } from "src/redux/reducers/countries";
import { Country } from "src/types/Country";

export const getCountriesState = (state): CountriesI => state.countries;

export function* fetchCountries({
  isGlobalRiskMap,
}: {
  type: string;
  isGlobalRiskMap: boolean;
}) {
  const countries: CountriesI = yield select(getCountriesState);
  if (!countries || !countries.countries || !countries.countries.length) {
    try {
      yield put(fetchCountriesInvoked());
      const payload: Country[] = yield call(fetchData, isGlobalRiskMap);
      yield put(fetchCountriesSuccess(payload));
    } catch (ex) {
      yield put(fetchCountriesFailed(ex));
    }
  }
}

function* countriesSaga() {
  yield takeLatest(COUNTRIES_FETCH_DATA, fetchCountries);
}

export default countriesSaga;
